
type TClassName = string | {[key: string]: boolean} | false | null | undefined
type TClassNames = Array<TClassName>

export const classNames = (...classNames: TClassNames) => {

    let result: string = ''

    const addClassName = (className: string) => {
        result = result ? `${result} ${className}` : `${className}`
    }

     classNames.forEach(className => {

         if (!className) {
             return
         }

        if (typeof className === "object" && Object.keys(className).length > 0) {
            Object.keys(className).forEach(key => {
                if (className[key]) {
                    addClassName(key)
                }
            })

            return;
        }


        addClassName(className as string)
    })

    return result
}